import { useContext } from "react"
import { MidiaContext } from "../contexts/MidiaContext/context"

export const useMidiaContext = () => {
   const values = useContext(MidiaContext)
   return values
}
